export default __webpack_public_path__ + "static/media/undraw_accept_request_re_d81h.a6a42a51.svg";